<template>
  <div>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar elevation="0">
            <v-btn @click="$router.go(-1)" icon>
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>

            <v-toolbar-title class="primary--text">
              {{ $capitalize($tc("model.products_new_product_title")) }}
            </v-toolbar-title>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>

    <ProductForm
      ref="productForm"
      @submit="createProduct"
      @cancel="$router.go(-1)"
    />

    <v-dialog v-model="loading" width="300" persistent>
      <v-card color="primary" dark>
        <v-card-text>
          {{ loadingProgressionText }}
          <v-progress-linear
            :value="loadingProgressionValue"
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ProductForm from "@/components/products/ProductForm";
import { getNewForm } from "@/services/products/products";
import i18n from "@/mixins/i18n";
import ToastsMixin from "@/mixins/ToastsMixin.vue";
import ProductMixin from "@/mixins/ProductMixin";

export default {
  components: {
    ProductForm,
  },

  mixins: [ToastsMixin, i18n, ProductMixin],

  data() {
    return {
      i18n_prefix: "products",
    };
  },

  computed: {
    lead_number() {
      return this.$route.params["lead_number"];
    },
  },

  async mounted() {
    try {
      const response = await getNewForm(this.lead_number);

      this.$refs.productForm.fill(response.data);
    } catch (error) {
      console.error("Erro ao carregar formulário do produto:", error);

      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Não foi possível carregar os dados do produto.";

      this.toastError(message);
    }
  },
};
</script>
